module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAVklEQVQ4y2NgGBTgQRDbf3LwcDLgPxbw/dL+/48TpP8/SVP+/+vBZWxK8Bvwdm4R3KaPmyaQbsCPW6f+P06S/f8kS/P/75f38RvAu0H7Pzl4OBkwtAEAGEKA8+iZprwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/NE.png
// module id = 1225
// module chunks = 0